import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "cookie-consent-preferences";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  function acceptAll() {
    setSaving(true);
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ necessary: true, analytics: true, marketing: true })
      );
      window.dispatchEvent(new CustomEvent('cookie-consent-updated', { detail: { necessary: true, analytics: true, marketing: true } }));
      setVisible(false);
    } catch {}
    setSaving(false);
  }

  function rejectAll() {
    setSaving(true);
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ necessary: true, analytics: false, marketing: false })
      );
      window.dispatchEvent(new CustomEvent('cookie-consent-updated', { detail: { necessary: true, analytics: false, marketing: false } }));
      setVisible(false);
    } catch {}
    setSaving(false);
  }

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50">
      <div className="w-full border-t border-border bg-gradient-to-r from-secondary/60 via-background to-secondary/60 backdrop-blur supports-[backdrop-filter]:bg-background/70">
        <div className="container mx-auto px-4 py-4 flex flex-col md:flex-row items-start md:items-center gap-4">
          <div className="flex-1 min-w-0">
            <p className="text-sm text-muted-foreground">
              Nous utilisons des cookies pour assurer le bon fonctionnement du site, mesurer l'audience et personnaliser
              certains contenus. Vous pouvez gérer vos préférences à tout moment sur la page
              <span> </span>
              <Link to="/cookies" className="underline underline-offset-4">Préférences cookies</Link>.
            </p>
          </div>
          <div className="flex items-center gap-2 ml-auto">
            <button
              className="px-3 py-2 rounded-md border border-border bg-secondary/50 hover:bg-secondary/70"
              onClick={rejectAll}
              disabled={saving}
            >
              Tout refuser
            </button>
            <button
              className="px-3 py-2 rounded-md bg-primary text-primary-foreground hover:opacity-90 shadow"
              onClick={acceptAll}
              disabled={saving}
            >
              Tout accepter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;


